import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject, Observable } from 'rxjs';
import { AppLoaderComponent } from './app-loader.component';

interface Config {
  width?: string
}

@Injectable()
export class AppLoaderService {
  private dialogRef: MatDialogRef<AppLoaderComponent> | null = null;
    private readonly disabledLoader = new BehaviorSubject<boolean>(false);

  public readonly disabledLoader$ = this.disabledLoader.asObservable();
  constructor(private dialog: MatDialog) { }

  public open(title: string = 'Please wait', config: Config = { width: '200px' }): Observable<boolean> {
    if (!this.dialogRef) {
      this.dialogRef = this.dialog.open(AppLoaderComponent, {
        disableClose: true,
        backdropClass: 'light-backdrop',
      });
      this.dialogRef.updateSize(config.width);
      this.dialogRef.componentInstance.title = title;
    }
    return this.dialogRef.afterClosed();
  }

  public close() {
    if (this.dialogRef) {
      this.dialogRef.close();
      this.dialogRef = null;
    }
  }
    public setLoaderDisabled(disabled: boolean): void {
    this.disabledLoader.next(disabled);
  }
}
